export const AttributeKinds = {
  DECLINED: 'declined',
  LIMITS: 'limits',
  DEDUCTIBLE: 'deductible',
} as const;

export type AttributeKind = (typeof AttributeKinds)[keyof typeof AttributeKinds];
